/* Floyd & Hamilton — single shared scroll-reveal mechanism.
   Adds .is-visible to any [data-fh-reveal] element as it enters the viewport.
   Staggers siblings that share a [data-fh-stagger] parent. Respects reduced motion. */
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Opt into the hidden-then-reveal start state ONLY when JS is running and motion is allowed.
  // Without this class the CSS keeps every [data-fh-reveal] element fully opaque, so content is
  // legible even if the observer never fires (no-JS, or a fast programmatic scroll capture).
  if (!reduce) document.documentElement.classList.add('fh-js');

  const reveal = (el) => el.classList.add('is-visible');

  const init = () => {
    const targets = document.querySelectorAll('[data-fh-reveal]:not(.is-visible)');
    if (!targets.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    // Assign stagger delays within each stagger group.
    document.querySelectorAll('[data-fh-stagger]').forEach((group) => {
      const items = group.querySelectorAll('[data-fh-reveal]');
      items.forEach((item, i) => {
        if (!item.style.getPropertyValue('--fh-reveal-delay')) {
          item.style.setProperty('--fh-reveal-delay', `${Math.min(i, 8) * 90}ms`);
        }
      });
    });

    const io = new IntersectionObserver((entries, obs) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        reveal(entry.target);
        obs.unobserve(entry.target);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    targets.forEach((t) => io.observe(t));
  };

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // Re-scan when Shopify theme editor injects/reloads a section.
  document.addEventListener('shopify:section:load', init);
})();
